export enum ItemWeapon {
  sword = "miecz",
  axe = "topor",
  dagger = "sztylet",
  hammer = "mlot",
  club = "maczuga",
  poleArm = "drzewiec",
}
